import { ClientsWorkOverviewColumn } from "@common/types/views/clientsWorkOverviewView";
import { clientsWorkOverviewViewConfig } from "./clientsWorkOverviewViewConfig";

const { columns } = clientsWorkOverviewViewConfig;

/** The Work page's config: My role is offered. */
export const workPageViewConfig: typeof clientsWorkOverviewViewConfig = {
    ...clientsWorkOverviewViewConfig,
    columns: {
        ...columns,
        [ClientsWorkOverviewColumn.MY_ROLE]: {
            ...columns[ClientsWorkOverviewColumn.MY_ROLE],
            internal: false,
            hiddenFromSettings: false,
        },
    },
};
